import React, { useState } from 'react';
import { useFormikContext } from 'formik';
import { cloneDeep } from 'lodash';
import PropTypes from 'prop-types';
import HeEntryForm from './HeEntryForm';
import HeEntryDisplay from './HeEntryDisplay';

function HeToggleableEntry(props) {
  const { entryData, mode } = props;
  const { values, setFieldValue } = useFormikContext();
  const [isToggled, setToggled] = useState(false);

  let EntryComponent = HeEntryDisplay;

  const handleToggle = () => {
    const updatedEntries = Object.assign(values.entries);
    if (!isToggled) {
      updatedEntries[entryData._id] = cloneDeep(entryData);
    } else {
      delete updatedEntries[entryData._id];
    }
    setFieldValue('entries', updatedEntries);
    setToggled(!isToggled);
  };

  const canToggle = isToggled || mode === 'edit';
  const toggleHandler = canToggle ? handleToggle : null;

  if (isToggled) {
    EntryComponent = HeEntryForm;
  }

  return <EntryComponent entryData={entryData} click={toggleHandler} />;
}

HeToggleableEntry.propTypes = {
  entryData: PropTypes.objectOf(PropTypes.any).isRequired,
  mode: PropTypes.string.isRequired,
};

export default HeToggleableEntry;
